import { z } from 'zod'

import { DateZod } from '../common'

export const AutomationLeaseZod = z.object({
  holder: z.string(),
  fencingToken: z.number().int().nonnegative().default(0),
  expiresAt: DateZod,
  rerunRequested: z.boolean().optional().default(false),
})
export type AutomationLease = z.infer<typeof AutomationLeaseZod>
